module.exports = __webpack_public_path__ + "img/ico-meeting_notes.3ed32a7.svg";